import React from 'react'
import './index.css'
import { formatDate } from '../../configTools/dateFormat'
import { unitCount } from '../../configTools/toothNumbering'

// Case details for the printed order label.
//
// An order can hold several line items, each with its own shade, due date and product. This
// COMBINES them - distinct values joined, earliest due date - rather than listing one row per
// item, because the label is a fixed 4x3in sticker: a per-item list grows with the item count
// and would be clipped. Nothing is hidden, and the height never varies.
//
// Empty fields render "-" rather than collapsing the row, again so the height is constant.

// Distinct, non-blank values of one key across all line items, in first-seen order.
const distinct = (items, key) => {
    const seen = [];
    items.forEach((item) => {
        const value = item && item[key];
        if (value === null || value === undefined) return;
        const text = String(value).trim();
        if (text !== '' && seen.indexOf(text) === -1) seen.push(text);
    });
    return seen.join(', ');
};

// The most urgent date wins - a technician needs the soonest deadline on the case, not the
// first line item's. Compared on the YYYY-MM-DD prefix, which is how dateFormat reads dates
// too, so no Date object is constructed and the day cannot shift by a timezone offset.
const earliestDate = (items, key) => {
    let best = null;
    let bestIso = null;
    items.forEach((item) => {
        const raw = item && item[key];
        if (!raw) return;
        const iso = String(raw).slice(0, 10);
        if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return;
        if (bestIso === null || iso < bestIso) { bestIso = iso; best = raw; }
    });
    return best;
};

const Index = ({ lineItems, orderdate }) => {
    const items = Array.isArray(lineItems) ? lineItems : [];
    const caseType = items
        .map((i) => [i.productname, i.servicename].filter(Boolean).join(' / '))
        .filter((t) => t !== '')
        .filter((t, i, all) => all.indexOf(t) === i)
        .join(', ');
    // Derived from the actual selected teeth rather than the stored `units` field, matching how
    // the billing statement counts units.
    const units = items.reduce((sum, i) => sum + unitCount(i.sections), 0);
    const dash = (v) => (v === null || v === undefined || String(v).trim() === '' ? '-' : v);

    const cell = (label, value, wide) => (
        <div className={'nv-lbl-case__cell' + (wide ? ' -wide' : '')}>
            <span className='nv-lbl-case__k'>{label}</span>
            <b className='nv-lbl-case__v'>{dash(value)}</b>
        </div>
    );

    return (
        <div className='nv-lbl-case'>
            {cell('Case', caseType, true)}
            {cell('Shade', distinct(items, 'shades'))}
            {cell('Units', units > 0 ? units : '')}
            {cell('Received', orderdate ? formatDate(orderdate) : '')}
            {cell('Due', (() => { const d = earliestDate(items, 'duedate'); return d ? formatDate(d) : ''; })())}
            {cell('Enclosed', distinct(items, 'enclosed'), true)}
        </div>
    )
}

export default Index
